<template>
  <div id="modal-table">
    <b-table
      class="add-document-table"
      :items="orders"
      :fields="fields"
      striped
      bordered
      foot-clone
    >
      <template slot="date">
        -
      </template>
      <template slot="ln">
        -
      </template>
      <template slot="patient">
        -
      </template>
      <template slot="spp">
        -
      </template>
      <template
        slot="test"
        slot-scope="data"
      >
        {{ data.item.item_name }}
      </template>
      <template
        slot="price"
        slot-scope="data"
      >
        {{ data.item.item_price }}
      </template>
      <template
        slot="quantity"
        slot-scope="data"
      >
        {{ data.item.item_quantity }}
      </template>
      <template
        slot="amount"
        slot-scope="data"
      >
        {{ data.item.item_price * data.item.item_quantity }}
      </template>
      <template slot="approver">
        -
      </template>
      <template slot="FOOT_date">
        <p />
      </template>
      <template slot="FOOT_ln">
        <p />
      </template>
      <template slot="FOOT_patient">
        <p />
      </template>
      <template slot="FOOT_spp">
        <p />
      </template>
      <template slot="FOOT_test">
        <p />
      </template>
      <template slot="FOOT_price">
        <p />
      </template>
      <template slot="FOOT_quantity">
        <strong>{{ totalQuantity }}</strong>
      </template>
      <template slot="FOOT_amount">
        <strong>{{ totalAmount }}</strong>
      </template>
      <template slot="FOOT_approver">
        <p />
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: "ConfirmAddOtherPlatformDocumentTableModal",
  props: {
    orders: {
      type: Array
    }
  },
  data() {
    return {
      fields: {
        date: {
          label: "วันที่สั่งตรวจ"
        },
        ln: {
          label: "LN"
        },
        patient: {
          label: "PATIENT"
        },
        spp: {
          label: "SPP"
        },
        test: {
          label: "รายการตรวจ"
        },
        price: {
          label: "ราคาต่อหน่วย"
        },
        quantity: {
          label: "จำนวน"
        },
        amount: {
          label: "ราคารวม"
        },
        approver: {
          label: "ผู้อนุมัติ"
        }
      }
    };
  },
  computed: {
    totalAmount() {
      let total = 0;
      this.orders.forEach(order => {
        total += +order.item_price * +order.item_quantity;
      });
      return total;
    },
    totalQuantity() {
      let total = 0;
      this.orders.forEach(order => {
        total += +order.item_quantity;
      });
      return total;
    }
  },
  mounted() {
    // console.log(this.orders);
  }
};
</script>

<style scoped></style>
